module.exports = __webpack_public_path__ + "img/CarFinance247_logo_purple.ed1baa72.svg";